<template>
  <div>
    <info-card
      :title="jobInfoTitle"
      :data="generalWorkInfo"
      :editJobInformation="editJobInformation"
      index="1"
      :reload="reload"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
      :isLoading="loading"
    ></info-card>
    <info-card
      :title="jobDescptionTitle"
      :data="employeeDepartmentsInfo"
      :editJobInformation="editJobInformation"
      index="1"
      :reload="reload"
      :get_error="get_error"
      :addEmployeeDepartment="addEmployeeDepartment"
      :empDepartmentsData="empDepartmentsData"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
      :isLoading="loading"
    ></info-card>

    <info-card
      :title="employeeContractsTitle"
      :data="employeeDepartmentsInfo"
      :editJobInformation="editJobInformation"
      index="1"
      :reload="reload"
      :get_error="get_error"
      :addEmployeeDepartment="addEmployeeDepartment"
      :empContracts="empContracts"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
      :isLoading="loading"
    ></info-card>

    <!-- <info-card
      v-if="userIsTerminated"
      :title="TerminationInfoTitle"
      :data="terminationInfo"
      :editJobInformation="editJobInformation"
      index="1"
      :reload="reload"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
      :isLoading="loading"
    ></info-card> -->

    <EditJobInformation
      v-if="showEditJobInformation"
      :close="close"
      @closeOnSuccess="closeOnSuccess"
      :showEditJobInformation="showEditJobInformation"
      :sectionData="sectionData"
      :reload="reload"
      :empData="empData"
      :terminationInfo="terminationInfo"
      :generalWorkInfo="generalWorkInfo"
      :employeeDepartmentsInfo="employeeDepartmentsInfo"
      :get_error="get_error"
      :edit_error="edit_error"
      :edit_success="edit_success"
      :item="item"
      :activeTitle="activeTitle"
      :isLoading="loading"
    >
    </EditJobInformation>
    <CreateEmployeeDepartment
      :showCreateEmployeeDepartment="showCreateEmployeeDepartment"
      :reload="reload"
      :closeCreateDepartment="closeCreateDepartment"
    ></CreateEmployeeDepartment>
  </div>
</template>

<script>
// import { formatDate } from "@/utils/formatDate";
import decryptData from '@/utils/decrypt';
import infoCard from '../infoCard.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'JobInformation',

  components: {
    infoCard,
    // EditEmployee: () =>
    //   import("@/components/employees/modals/editEmployee.vue"),
    EditJobInformation: () =>
      import('@/components/employees/modals/editJobInformation.vue'),
    CreateEmployeeDepartment: () =>
      import('@/components/employees/modals/createEmployeeDepartment.vue'),
  },

  data() {
    return {
      showEditJobInformation: false,
      showCreateEmployeeDepartment: false,
      jobInfoTitle: 'General Work Information',
      jobDescptionTitle: 'Employee Departments',
      AdditionalWorkInfoTitle: 'Additional Work Information',
      TerminationInfoTitle: 'Termination Information',
      employeeContractsTitle: 'Employee Contracts',
      userIsTerminated: true,
      get_error: null,
      empData: null,
      sectionData: null,
      empDepartmentsData: [],
      empContracts: [],
      generalWorkInfo: [],
      AdditionalWorkInfo: [],
      terminationInfo: [],
      employeeDepartmentsInfo: [],
      activeTitle: null,
      item: null,
      edit_success: null,
      edit_error: null,
      jobGrades: [],
      employmentTypes: [],
      employmentStatus: [],
      activeConract: [],
      loading: false,
      jobTitles:[]
    };
  },
  computed: {
    ...mapGetters([
      'getOrganization',
      'getToken',
      'getTabTitle',
      'getCurrentEmployeeId',
      'getUserRole',
    ]),
  },
  created() {
    if (this.getUserRole.toLowerCase() === 'hrmanager') {
      this.getEmploymentTypes();
      this.getJobGrades();
      this.getEmploymentStatus();
      this.getJobTitles()
    }
    const Id = this.getCurrentEmployeeId;
    this.getJobInfo(Id);
  },
  watch: {
    showCreateEmployeeDepartment(old, ishRefresh) {
      if (ishRefresh) {
        this.reload();
      }
    },
  },

  methods: {
    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {

                  this.jobTitles = response.data.Data;
                  console.log(this.jobTitles)
                } else {
                  this.get_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.get_error = error.message;
              }
          );
    },
    reload() {
      const Id = this.getCurrentEmployeeId;
      this.getJobInfo(Id);
      // this.getEmployeeDepartments
      this.showCreateEmployeeDepartment = false;
      this.showEditJobInformation = false;
      this.$forceUpdate();
    },
    closeCreateDepartment() {
      this.showCreateEmployeeDepartment = false;
    },
    close() {
      this.showEditJobInformation = false;
    },
    addEmployeeDepartment() {
      this.showCreateEmployeeDepartment = true;
    },
    editJobInformation() {
      this.showEditJobInformation = true;

      //console.log(this.getTabTitle.trim(), 1111)
      switch (this.getTabTitle.trim()) {
        case 'General Work Information':
          this.empData = this.generalWorkInfo;
          this.sectionData = this.generalWorkInfo;
          this.sectionData.formdata = {
            FullNames: '',
            EmployeeId: '',
            EmploymentType: '',
            WorkEmail: '',
            OfficeTown: '',
            OfficeCountry: '',
            Department: '',
            Grade: '',
            DateOfJoining: '',
            PayrollNumber: '',
            EmploymentStatus: '',
          };
          // //console.log(this.empData, this.sectionData, 111)
          break;

        case 'Employee Departments':
          this.empData = this.employeeDepartmentsInfo;
          this.sectionData = this.employeeDepartmentsInfo;
          this.sectionData.formdata = [];
          break;

        // case "Termination Information":
        //   this.empData = this.terminationInfo;
        //   this.sectionData = this.terminationInfo;
        //   this.sectionData.formdata = {
        //     TerminationDate: "",
        //     TerminationCategory: "",
        //     NoticeDate: "",
        //     TerminationReason: "",
        //   };
        //   break;

        default:
          break;
      }
    },
    // /{organization}/employee/{employeeId}/job/information/v1/request
    getJobInfo(id) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/${id}/job/information/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data);
          }
        });
      this.loading = true;
      this.$store.commit('setIsLoading', this.loading);
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/job/information/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.JobInfo = response.data.Data;

              const {
                generalWorkInformation,

                employeeDepartments,
                contracts,
              } = this.JobInfo;
              // console.log(contracts);
              this.empDepartmentsData = employeeDepartments;
              this.empContracts = contracts;

              this.activeConract = contracts.length
                ? contracts.find(
                    (contract) =>
                      contract.EmploymentStatus?.toLowerCase()?.trim() ===
                      'active'
                  )
                : {};
              (this.generalWorkInfo = [
                {
                  Id: generalWorkInformation.Id,
                  EmployeeId: generalWorkInformation.EmployeeId,
                  LocationId: generalWorkInformation.LocationId,
                  name: 'EmployeeNo',
                  value: generalWorkInformation.EmployeeId,
                  label: 'EmployeeNo',
                },

                {
                  name: 'Job Title',
                  value: generalWorkInformation.JobTitle,
                  label: 'JobTitle',
                  type:"select",
                  options:this.jobTitles,
                  index:6
                },

                {
                  name: 'Work Email',
                  value: decryptData(
                    generalWorkInformation.WorkEmail,
                    this.$decryptionKey
                  ),
                  type: 'email',
                  index: 0,
                  label: 'WorkEmail',
                },

                // {
                //   name: "Type",
                //   value: generalWorkInformation.EmployementType,
                //   type: "select",
                //   index: 0,
                //   options: this.employmentTypes,
                //   label: "EmploymentType",
                // },

                {
                  name: 'Grade',
                  value: generalWorkInformation?.JobGrade,
                  index: 5,
                  type: 'select',
                  options: this.jobGrades,
                  label: 'GradeId',
                },
                {
                  name: 'Date of Joining',
                  value: moment(generalWorkInformation?.DateOfJoining).format(
                    'YYYY-MM-DD'
                  ),
                  // generalWorkInformation?.DateOfJoining,
                  type: 'date',
                  label: 'DateOfJoining',
                },

                // {
                //   name: 'Start Date',
                //   value: moment(this.activeConract?.StartDate).format(
                //     'YYYY-MM-DD'
                //   ),
                //   type: 'date',
                //   label: 'StartDate',
                // },
                // {
                //   name: 'End Date',
                //   value: moment(this.activeConract?.EndDate).format(
                //     'YYYY-MM-DD'
                //   ),
                //   type: 'date',
                //   label: 'EndDate',
                // },

                {
                  name: 'Status',
                  value: generalWorkInformation?.EmployementStatus,
                  type: 'select',
                  index: 4,
                  options: this.employmentStatus,
                  label: 'EmploymentStatus',
                },
              ]),
                (this.employeeDepartmentsInfo = [
                  {
                    name: 'Employee Departments',
                    value: employeeDepartments,
                    label: 'employeeDepartments',
                    type: 'select',
                    index: 1,
                    options: [employeeDepartments],
                  },
                ]);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getJobGrades() {
      this.loading = true;
      this.$store.commit('setIsLoading', this.loading);
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobgrade/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            if (response.data.StatusCode == 200) {
              console.log(response.data.Data)
              this.jobGrades = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            this.get_error = error.message;
          }
        );
    },
    getEmploymentTypes() {
      this.loading = true;
      this.$store.commit('setIsLoading', this.loading);
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            if (response.data.StatusCode == 200) {
              this.employmentTypes = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getEmployeeContracts() {
      this.loading = true;
      this.$store.commit('setIsLoading', this.loading);
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            if (response.data.StatusCode == 200) {
              this.employmentTypes = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            this.get_error = error.message;
          }
        );
    },
    getEmploymentStatus() {
      this.loading = true;
      this.$store.commit('setIsLoading', this.loading);
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            if (response.data.StatusCode == 200) {
              this.employmentStatus = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.$store.commit('setIsLoading', this.loading);
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
